export default __webpack_public_path__ + "static/media/review_8.b1e2ca51.webp";